import { render, staticRenderFns } from "./ConfirmDeleteNeedDialog.vue?vue&type=template&id=f0f4848c&scoped=true"
import script from "./ConfirmDeleteNeedDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteNeedDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteNeedDialog.vue?vue&type=style&index=0&id=f0f4848c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f4848c",
  null
  
)

export default component.exports